import React, { useCallback } from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { SortableContainer } from 'react-sortable-hoc';
import useStyles from './styles';
import AccordionItem from './AccordionItem';
import { useBlocks } from '../../hooks/context/useBlocks.hook';

const BlocksAccordion = SortableContainer(({
  itemsSelected,
  setTotalSelected,
  setContent,
  content,
  saveBlocks,
  deleteBlock,
  rowsPerPage,
  setRowsPerPage,
}) => {
  const { blocks, setBlocks } = useBlocks();

  const classes = useStyles();
  const onSelectItem = (e, item) => {
    e.stopPropagation();
    if (!itemsSelected.has(item.id)) {
      itemsSelected.set(item.id, item);
    } else {
      itemsSelected.delete(item.id);
    }
    setTotalSelected(itemsSelected.size);
  };

  const setMainBlockContent = (content) => {
    setContent(content);
  };

  const setBlockContent = useCallback((id, content) => {
    setBlocks(blocks => {
      const updatedBlocks = [...blocks];
      updatedBlocks[id] = { ...updatedBlocks[id], content };
      return updatedBlocks;
    });
  }, [setBlocks]);

  const setBlockSubTitle = useCallback((id, subtitle) => {
    setBlocks(blocks => {
      const updatedBlocks = [...blocks];
      updatedBlocks[id] = { ...updatedBlocks[id], subtitle };
      return updatedBlocks;
    });
  }, [setBlocks]);

  const discardUnsavedBlock = (blockIndex) => {
    const aux = [...[], ...blocks];
    aux.splice(blockIndex, 1);
    setBlocks(aux);
  };

  return (
    <Box>
      <Box className={classes.root} display="flex" flexDirection="column">
        <AccordionItem
          mainBlock
          index={0}
          disabled
          setContent={setMainBlockContent}
          setBlockSubTitle={setBlockSubTitle}
          content={content}
          block={
            {
              id: 0,
              subtitle: 'CONTENT',
            }
          }
        />
        {blocks.map((block, index) => (
          <AccordionItem
            key={`block-${block.id}`}
            idx={index}
            index={index + 1}
            setContent={setBlockContent}
            setBlockSubTitle={setBlockSubTitle}
            content={block.content}
            block={block}
            onSelectItem={onSelectItem}
            saveBlocks={saveBlocks}
            deleteBlock={deleteBlock}
            discardUnsavedBlock={discardUnsavedBlock}
          />
        ))}
      </Box>
      <Box mt={2} display="flex" justifyContent="flex-end">
        <FormControl className={classes.formControl} variant="filled">
          <InputLabel id="select-rows-per-page">Rows per page</InputLabel>
          <Select
            labelId="select-rows-per-page"
            id="rows-per-page"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(e.target.value)}
            mb={2}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={15}>15</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
});

export default BlocksAccordion;
